import React, { useState } from "react";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Fade from "@mui/material/Fade";
import { Drawer, IconButton, Box } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const DrawerComp = () => {
  const [value, setValue] = useState();

  const [openDrawer, setOpenDrawer] = useState(false);

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <React.Fragment>
      <Drawer
        anchor="top"
        open={openDrawer}
        onClose={() => setOpenDrawer(false)}
        width="100%"
      >
        <Box>
          <Box>
            {" "}
            <Button
              sx={{
                width: "100%",
                justifyContent: "left",
                textTransform: "capitalize",
              }}
            >
              Home
            </Button>
          </Box>
          <Box>
            {" "}
            <Button
              sx={{
                width: "100%",
                justifyContent: "left",
                textTransform: "capitalize",
              }}
            >
              About
            </Button>
          </Box>

          <Box>
            <Accordion
              sx={{ width: "100%", boxShadow: "none", padding: "0px" }}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon color="primary" />}
                aria-controls="panel1a-content"
                // id="panel1a-header"
                sx={{ border: "none", padding: "0px", pl: "9px" }}
                Paper
              >
                <Typography color="primary">Services</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Box>
                  <MenuItem
                    onClick={handleClose}
                    color="primary"
                    sx={{
                      fontSize: {
                        lg: "16px",
                        md: "16px",
                        sm: "14px",
                        xs: "12px",
                      },
                      fontWeight: "400",
                      color: "#2b817b",
                    }}
                  >
                    <Box
                      sx={{
                        width: "20px",
                        height: "18px",
                        paddingRight: "8px",
                      }}
                    >
                      <img src="./images/tag-user.svg" width="100%" alt="" />
                    </Box>{" "}
                    Personal Subscription
                  </MenuItem>

                  <MenuItem
                    onClick={handleClose}
                    color="primary"
                    sx={{
                      fontSize: {
                        lg: "16px",
                        md: "16px",
                        sm: "14px",
                        xs: "12px",
                      },
                      fontWeight: "400",
                      color: "#2b817b",
                    }}
                  >
                    <Box
                      sx={{
                        width: "20px",
                        height: "18px",
                        paddingRight: "8px",
                      }}
                    >
                      <img src="./images/bubble.svg" width="100%" alt="" />
                    </Box>
                    Multiple Subscription
                  </MenuItem>
                  <MenuItem
                    onClick={handleClose}
                    color="primary"
                    sx={{
                      fontSize: {
                        lg: "16px",
                        md: "16px",
                        sm: "14px",
                        xs: "12px",
                      },
                      fontWeight: "400",
                      color: "#2b817b",
                    }}
                  >
                    <Box
                      sx={{
                        width: "20px",
                        height: "18px",
                        paddingRight: "8px",
                      }}
                    >
                      <img src="./images/building.svg" width="100%" alt="" />
                    </Box>
                    Business Subscription
                  </MenuItem>
                  <MenuItem
                    onClick={handleClose}
                    color="primary"
                    sx={{
                      fontSize: {
                        lg: "16px",
                        md: "16px",
                        sm: "14px",
                        xs: "12px",
                      },
                      fontWeight: "400",
                      color: "#2b817b",
                    }}
                  >
                    <Box
                      sx={{
                        width: "20px",
                        height: "18px",
                        paddingRight: "8px",
                      }}
                    >
                      <img src="./images/weight.svg" width="100%" alt="" />
                    </Box>
                    Fitness Subscription
                  </MenuItem>
                  <MenuItem
                    onClick={handleClose}
                    color="primary"
                    sx={{
                      fontSize: {
                        lg: "16px",
                        md: "16px",
                        sm: "14px",
                        xs: "12px",
                      },
                      fontWeight: "400",
                      color: "#2b817b",
                    }}
                  >
                    <Box
                      sx={{
                        width: "20px",
                        height: "18px",
                        paddingRight: "8px",
                        color: "#2b817b",
                      }}
                    >
                      <img src="./images/cake.svg" width="100%" alt="" />
                    </Box>
                    Event Catering
                  </MenuItem>
                </Box>
              </AccordionDetails>
            </Accordion>
          </Box>

          <Box>
            {" "}
            <Button
              sx={{
                width: "100%",
                justifyContent: "left",
                textTransform: "capitalize",
              }}
            >
              Contact
            </Button>
          </Box>
        </Box>
      </Drawer>
      <IconButton
        sx={{ color: "#000000", marginLeft: "auto" }}
        onClick={() => setOpenDrawer(!openDrawer)}
      >
        <MenuIcon color="white" />
      </IconButton>
    </React.Fragment>
  );
};

export default DrawerComp;
